module.exports = __webpack_public_path__ + "img/pdf.7628604e.svg";